export const filterActiveRecords = (records = []) => {
  return records.filter((record) => Number(record?.del_flg ?? 0) === 0);
};
